import { useState } from 'react'

export const useToggle = (initialState = false) => {
  const [isOpen, setIsOpen] = useState(initialState)

  const toggle = () => {
    setIsOpen((value) => { return !value })
  }

  return [isOpen, toggle]
}
